module.exports = __webpack_public_path__ + "static/cloud-16d1d0dfa7a49bfd278124128f17893a.png";